import React from "react"

import { Link } from "gatsby"

import { Wrapper } from "../components/base/wrapper/wrapper"
import { SEO } from "../components/base/seo/seo"
import { HeroBannerPartnership } from "../components/modules/hero-banner/hero-banner-partnership.js"

const PartnershipTemplate = () => (
  <Wrapper>
    <SEO
      title="Partnership Template"
      description="New template for partnership page"
    />

    <HeroBannerPartnership />
  </Wrapper>
)

export default PartnershipTemplate
